import { render, staticRenderFns } from "./SyslogConfigModal.vue?vue&type=template&id=62facdf7&"
import script from "./SyslogConfigModal.vue?vue&type=script&lang=js&"
export * from "./SyslogConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports